import classNames from "classnames";
import {ComponentType, ReactNode} from "react";

import {Divider} from "@/components/divider/Divider.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {OnboardingWizardStep} from "@/lib/types/accounts.ts";
import {SkipButton} from "@/pages/onboardingwizard/components/skipbutton/SkipButton.tsx";

import styles from "./Step.module.scss";
export interface SubmitProps {
  onSubmit: (nextStep: number, updateAnalytics: boolean) => void;
  stepsCount: number;
}

export interface StepBodyProps extends SubmitProps {
  setAnalyticsErrorMessage: (message: string) => void;
  activeStepNr: number;
}

export interface StepContent {
  name: OnboardingWizardStep;
  title: string;
  subtitle?: string;
  infotext?: string | ReactNode;
  iconURL?: string;
  iconPosition?: "top" | "left";
  body: ComponentType<StepBodyProps>;
}

interface StepProps extends StepContent, StepBodyProps {
  analyticsErrorMessage: string;
}

export const Step = (stepProps: StepProps) => {
  return (
    <div className={styles.step}>
      <div className={styles.stepHeader}>
        <div
          className={classNames(styles.title, stepProps.iconPosition ? styles["icon-" + stepProps.iconPosition] : "")}
        >
          {stepProps.iconURL && (
            <img
              src={stepProps.iconURL}
              alt={stepProps.title}
              className={styles.titleIcon}
              role="img"
              aria-label="title-icon"
            />
          )}
          <div className="pulseTextH1Bold">{stepProps.title}</div>
        </div>
        {stepProps.subtitle && (
          <div className="pulseTextBody pulse-color-gray-700 mt-3">
            {stepProps.subtitle}
            {stepProps.infotext && (
              <TooltipIconRA
                className="ms-1 pulse-color-gray-600"
                title={stepProps.infotext}
                iconProps={{
                  display: "inline",
                  removeDivDimensions: true,
                }}
              />
            )}
          </div>
        )}
        <SkipButton
          onSubmit={stepProps.onSubmit}
          stepsCount={stepProps.stepsCount}
          activeStepNr={stepProps.activeStepNr}
        />
      </div>
      <Divider className="w-100" />
      <div className={styles.stepBody}>
        {stepProps.analyticsErrorMessage !== "" && (
          <b className="invalid-feedback d-block mb-4">{stepProps.analyticsErrorMessage}</b>
        )}
        <stepProps.body
          onSubmit={stepProps.onSubmit}
          setAnalyticsErrorMessage={stepProps.setAnalyticsErrorMessage}
          stepsCount={stepProps.stepsCount}
          activeStepNr={stepProps.activeStepNr}
        />
      </div>
    </div>
  );
};
